import { render, staticRenderFns } from "./StripeBridgeMetadataRows.vue?vue&type=template&id=630a4c2c&scoped=true"
import script from "./StripeBridgeMetadataRows.vue?vue&type=script&lang=js"
export * from "./StripeBridgeMetadataRows.vue?vue&type=script&lang=js"
import style0 from "./StripeBridgeMetadataRows.vue?vue&type=style&index=0&id=630a4c2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630a4c2c",
  null
  
)

export default component.exports